var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lib__header__grid--img-text-container "},[_vm._t("default"),_c('p',{staticClass:"lib__header__grid--text lib__text-info lib__no-margin"},[_vm._v(_vm._s(_vm.header))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }